const normalize = (value) => String(value || "").normalize("NFKC").toLocaleLowerCase();

export const getHandoutAssetFolder = (file, prefix = "") => {
  const key = String(file?.key || "");
  const relative = prefix && key.startsWith(prefix) ? key.slice(prefix.length).replace(/^\/+/, "") : key;
  return relative.includes("/") ? relative.slice(0, relative.lastIndexOf("/")) : "";
};

export const getHandoutAssetFolders = (files, prefix) => [...new Set((files || [])
  .map((file) => getHandoutAssetFolder(file, prefix)))].sort((a, b) => a.localeCompare(b, "zh-Hant", { numeric: true }));

export const getHandoutRoleFolder = (role, folders) => {
  const category = { chapter: "02_單元標題", focus: "03_教學標籤", type: "04_題型標題", practice: "03_教學標籤", wave: "08_分隔裝飾" }[role];
  return category ? folders.find((folder) => folder.split("/").pop() === category) || "" : "";
};

export const filterHandoutAssets = (files, { search = "", folder = "", prefix = "" } = {}) => {
  const terms = normalize(search).trim().split(/\s+/).filter(Boolean);
  return (files || []).filter((file) => (!folder || getHandoutAssetFolder(file, prefix) === folder) &&
    terms.every((term) => normalize(`${file.name || ""} ${file.key || ""}`).includes(term)))
    .sort((a, b) => String(a.name || a.key).localeCompare(String(b.name || b.key), "zh-Hant", { numeric: true }));
};

export const handoutIconSize = (icon, fallback = {}) => {
  const clean = (value, other) => {
    const number = Number(value ?? other);
    return Number.isFinite(number) && number > 0 ? Math.min(18, Math.max(0.2, number)) : undefined;
  };
  return {
    width_cm: clean(icon?.width_cm ?? icon?.widthCm, fallback.width_cm),
    height_cm: clean(icon?.height_cm ?? icon?.heightCm, fallback.height_cm),
  };
};

export const serializeHandoutIcon = (icon) => ({
  key: icon.key,
  name: icon.name || String(icon.key || "").split("/").pop(),
  url: icon.url,
  ...Object.fromEntries(Object.entries(handoutIconSize(icon)).filter(([, value]) => value !== undefined)),
});
